<template>
  <van-popup v-model="popShow" position="bottom" :style="{ maxHeight: popHeight + 'px' }">
    <div class="header"></div>
    <div v-if="popShow" ref="selectPopup" class="select_popup" :style="{ maxHeight: popHeight + 'px' }">
      <van-index-bar :index-list="indexList">
        <template v-for="item in list">
          <van-index-anchor :index="item.type" :style="{ textAlign: $store.state.isMirroring ? 'right' : 'left' }" />
          <template v-for="each in item.data">
            <van-cell @click="selectItem(each)" class="cell">
              <div class="item">{{ each[showText] }}</div>
            </van-cell>
          </template>
        </template>
      </van-index-bar>
    </div>
  </van-popup>
</template>
<script>
import CommonInput from '@/components/CommonInput'
import CommonBtn from '@/components/CommonBtn.vue'

export default {
  name: 'LinkAccountSelect',
  components: {
    CommonInput,
    CommonBtn
  },
  props: {
    value: { type: Boolean, required: true, default: false },
    list: { type: Array, required: true, default: [] },
    indexList: { type: Array, required: true, default: [] },
    showText: { type: String, required: true },
    onSelect: Function,
    onShow: Function
  },
  data() {
    return {
      popShow: false,
      popHeight: 0
    }
  },
  watch: {
    value(val) {
      this.popShow = val
      if (val) {
        setTimeout(() => {
          this.$refs.selectPopup.scrollTop = 1
        }, 300)
      }
    },
    popShow(val) {
      if (this.onShow) {
        this.onShow(val)
      }
    }
  },
  mounted() {
    this.popHeight = visualViewport.height * 0.86
  },
  methods: {
    selectItem(item) {
      if (this.onSelect) {
        this.onSelect(item)
      }
      this.closePopup()
    },
    // 关闭并清空状态
    closePopup() {
      this.popShow = false
    }
  }
}
</script>
<style scoped>
.select_popup {
  padding: 0.24rem;
  padding-top: 0;
  background: #fff;
  border-radius: 0.16rem 0.16rem 0 0;
  position: relative;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.cell {
  padding: 0;
}

.item {
  height: 0.48rem;
  line-height: 0.48rem;
}

.header {
  position: fixed;
  background: #fff;
  width: 100%;
  height: 0.48rem;
  /* z-index: 1; */
  border-radius: 0.16rem 0.16rem 0 0;
}

.cell::after {
  content: none;
}
</style>
<style>
.select_popup .van-index-anchor {
  /* background: transparent; */
  height: 0.48rem;
  line-height: 0.48rem;
  color: #2f2f2f;
  font-size: 0.16rem;
  padding: 0;
}
.select_popup .van-index-bar__index {
  margin-inline-end: 0.1rem;
  padding: 0;
  width: 0.13rem;
  height: 0.13rem;
  color: #2f2f2f;
  text-align: center;
  font-family: 'PingFang SC';
  font-size: 0.09rem;
  font-style: normal;
  font-weight: 600;
  border-radius: 0.04rem;
  background: #fff;
  z-index: 3;
}

.select_popup .van-index-bar__index + span {
  margin-top: 0.05rem;
}

.select_popup .van-index-bar__index--active {
  color: #fff;
  background: #3fbb70;
}

.select_popup .van-index-bar__sidebar {
  top: calc(50% + 10vh);
}
.select_popup .van-hairline--bottom::after {
  content: none;
}
</style>



// WEBPACK FOOTER //
// src/components/LinkAccount/Select.vue